import React from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Tooltip from '@mui/material/Tooltip';
import { fontSize, palette } from '../../..';

interface DropZoneHeaderProps {
  isFilterCollapsed: boolean;
  setIsFilterCollapsed: (collapsed: boolean) => void;
  handleClick: (event: React.MouseEvent<SVGSVGElement>) => void;
  bIndex: number;
  currentChartAxes: any;
  propKey: string;
  chartProp: any;
  toggleFilterRunState: (propKey: string, runState: any) => void;
}

const DropZoneHeader: React.FC<DropZoneHeaderProps> = ({
  isFilterCollapsed,
  setIsFilterCollapsed,
  handleClick,
  bIndex,
  currentChartAxes,
  propKey,
  chartProp,
  toggleFilterRunState,
}) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        gap: '0.22rem',
        marginLeft: 'auto',
        alignItems: 'center',
      }}
    >
      <MoreVertIcon
        onClick={handleClick}
        style={{
          height: fontSize.extraLarge,
          width: fontSize.extraLarge,
          color: palette.primary.contrastText,
        }}
      />
      {!isFilterCollapsed ? (
        <Tooltip
          title="Click to Collapse"
          slotProps={{
            tooltip: {
              sx: {
                fontSize: '12px',
              },
            },
          }}
        >
          <ExpandMoreIcon
            style={{
              height: fontSize.extraLargePlus,
              width: fontSize.extraLargePlus,
              color: palette.primary.contrastText,
            }}
            onClick={() => {
              setIsFilterCollapsed(!isFilterCollapsed);
            }}
          />
        </Tooltip>
      ) : (
        <Tooltip
          title="Click to Expand"
          slotProps={{
            tooltip: {
              sx: {
                fontSize: '12px',
              },
            },
          }}
        >
          <KeyboardArrowRightIcon
            style={{
              height: fontSize.extraLargePlus,
              width: fontSize.extraLargePlus,
              color: palette.primary.contrastText,
            }}
            onClick={() => {
              setIsFilterCollapsed(!isFilterCollapsed);
            }}
          />
        </Tooltip>
      )}

      {bIndex === 0 && currentChartAxes[0].is_auto_filter_enabled === false ? (
        <button
          onClick={() =>
            toggleFilterRunState(propKey, !chartProp.properties[propKey].filterRunState)
          }
        >
          Run
        </button>
      ) : null}
    </div>
  );
};

export default DropZoneHeader;
